import { Stepper } from "components/Stepper";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

type AddSingleBuildingStepperProps = {
  changeStep?: (stepNo: number) => void;
  currentStep?: number;
};

export const AddSingleBuildingStepper = ({ changeStep, currentStep = 1 }: AddSingleBuildingStepperProps) => {
  const { t } = useTranslation();

  const step_items = useMemo(
    () => [
      {
        name: "address",
        title: t("AddBuilding.singleBuildingStepper.stepName.address"),
      },
      {
        name: "buildingSummary",
        title: t("AddBuilding.singleBuildingStepper.stepName.buildingSummary"),
      },
      {
        name: "buildingOutline",
        title: t("AddBuilding.singleBuildingStepper.stepName.buildingOutline"),
      },
      {
        name: "rooftopObjects",
        title: t("AddBuilding.singleBuildingStepper.stepName.rooftopObjects"),
      },
      {
        name: "buildingDetails",
        title: t("AddBuilding.singleBuildingStepper.stepName.buildingDetails"),
      },
      {
        name: "energyAndAnalysis",
        title: t("AddBuilding.singleBuildingStepper.stepName.energyAndAnalysis"),
      },
    ],
    [t]
  );

  return (
    <div className="w-full border-b bg-lds-surface-bright py-10 border-ds-subtle">
      <div className="mx-auto flex w-fit justify-center">
        <Stepper currentStep={currentStep} onCompletedStepClick={changeStep} steps={step_items} />
      </div>
    </div>
  );
};
